import { render, staticRenderFns } from "./FamilyMemberProfileAdd.vue?vue&type=template&id=166e4d21&scoped=true"
import script from "./FamilyMemberProfileAdd.vue?vue&type=script&lang=js"
export * from "./FamilyMemberProfileAdd.vue?vue&type=script&lang=js"
import style0 from "./FamilyMemberProfileAdd.vue?vue&type=style&index=0&id=166e4d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166e4d21",
  null
  
)

export default component.exports